module.exports = __webpack_public_path__ + "img/heart-health.7cbc60f4.png";